/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

export const modalColumnDefinitions = [
    {
        field: "nav_title",
        headerName: "Title",
        width: 250,
        editable: true,
    },
    {
        field: "status",
        headerName: "Status",
        width: 100,
        editable: true,
    },
    {
        field: "path",
        headerName: "Location",
        width: 300,
        editable: true,
    },
];
